import { Grid, GridProps, Paper } from "@mui/material";

interface Grid12Props extends GridProps {
	children?: React.ReactNode
}

const GridUI = (props: Grid12Props) => (
	<Grid 
		{...props}
		// item xs={12}
	>
		<Paper
			sx={{
				p: 2,
				display: "flex",
				flexDirection: "column",
			}}
		>
			{props.children}
		</Paper>
	</Grid>
);

export default GridUI;
